/*
 *		Copyright (c) 2011-2017 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Session')
    .directive('accSessionTimeoutPrompt', ['$window', '$translate', '$location', '$modal', '$interval', 'relativeUrlRootFilter', 'SessionTimeout', 'Session', 'ReturnPage', '$http',
        function ($window, $translate, $location, $modal, $interval, relativeUrlRootFilter, SessionTimeout, Session, ReturnPage, $http) {
            var
                MODAL_TITLE = 'You will be logged out soon...',
                CONTINUE_BUTTON = "Don't log me out",
                SIGN_OUT_BUTTON = 'Sign out',
                uploading = false;

            return function ($scope) {
                $scope.$on('uploading', function (event, isUploading) {
                    uploading = isUploading;
                });

                var sessionTimeoutInSeconds = Session.settings['session_timeout_in_minutes'] * 60,
                    timeUntilPromptAppearsInSeconds = sessionTimeoutInSeconds - _getPromptCountdownInSeconds(sessionTimeoutInSeconds);

                SessionTimeout.register(timeUntilPromptAppearsInSeconds, _handleTimeout);
                SessionTimeout.restart();
            };

            function _getPromptCountdownInSeconds(sessionTimeoutInSeconds) {
                return sessionTimeoutInSeconds <= 120 ? 30 : 120;
            }

            function _handleTimeout() {
                if (uploading) {
                    _renewSessionExpiration();
                } else {
                    _openTimeoutPrompt();
                }
            }

            function _renewSessionExpiration() {
                var promise = $http.post(relativeUrlRootFilter('/web_sessions/renew'), {});

                promise.then(function () {
                    SessionTimeout.restart();
                });

                return promise;
            }

            function _openTimeoutPrompt() {
                $modal.open({
                    domOptions: {
                        modalType: 'confirm',
                        modalTitle: $translate.instant(MODAL_TITLE),
                        modalActionButton: $translate.instant(CONTINUE_BUTTON),
                        modalCancelButton: $translate.instant(SIGN_OUT_BUTTON),
                        modalBodyTemplate: 'account/session_expiration'
                    },
                    controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                        var
                            countdown = $interval(function () {
                                $scope.remainingSeconds--;
                                if ($scope.remainingSeconds <= 0) {
                                    $scope.cancel();
                                }
                            }, 1000);

                        $modalInstance.result.finally(function () {
                            $interval.cancel(countdown);
                        });

                        $scope.modal = $modalInstance.options;
                        $scope.remainingSeconds = _getPromptCountdownInSeconds(Session.settings['session_timeout_in_minutes'] * 60);

                        $scope.ok = function () {
                            _renewSessionExpiration().then(function () {
                                $modalInstance.close('ok');
                            });
                        };

                        $scope.close = function () {
                            $scope.ok();
                        };

                        $scope.cancel = function () {
                            ReturnPage.set($location.path());
                            $window.location = Session.account['signout_link'];
                            $modalInstance.dismiss('signout');
                        };

                    }],
                    windowClass: 'confirmation-dialog',
                    backdrop: 'static',
                    keyboard: false
                });

            }
        }]);
